import { Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { CrudComponent } from "src/app/components/shared/cruds/crud.component";
import { CrudForm } from "src/app/components/shared/cruds/crud.form";
import { AlertasSwalService } from "src/app/services/alerts.service";
import { BlackListService } from "./blacklist.service";
import { FabButtonService } from "src/app/services/fab-button.service";
import { DrawerService } from "src/app/services/drawer.service";
import { BlackilistDrawerForm } from "./drawer-form/drawer-form.component";

@Component({
  selector: "app-blacklist",
  templateUrl: "./blacklist.component.html",
  styles: [],
})
export class BlackListComponent
  extends CrudComponent<any>
  implements OnInit, OnDestroy
{
  columnId: string = "";
  filtro: string = "";
  realdata: any[];
  list: any[];

  @ViewChild("formulario")
  public formulario: CrudForm<any>;

  btnAgregar = {
    backgroundClass: "bg-blue-500 hover:w-52",
    iconClass: "fas fa-plus",
    title: "Agregar a lista negra",
    action: () => {
      this.openUser();
    },
  };
  constructor(
    public service: BlackListService,
    public alerts: AlertasSwalService,
    public fab: FabButtonService,
    public drawer: DrawerService,
  ) {
    super(service, alerts);
  }
  ngOnDestroy(): void {
    this.fab.removeButton(this.btnAgregar);
  }

  ngOnInit() {
    this.Init();
    this.fab.addButton(this.btnAgregar);
  }
  loadRecords() {
    this.service.get().subscribe(
      (resultData) => {
        this.realdata = resultData;
        this.filterdata();
      },
      (err) => {
        this.alerts.error("error", err.error.Message);
      },
    );
  }

  filterdata() {
    let filterdata = this.realdata;

    if (this.filtro.trim().length > 0)
      filterdata = filterdata.filter(
        (f) =>
          (f.Nombre.toLocaleLowerCase() as string).indexOf(
            this.filtro.toLocaleLowerCase().trim(),
          ) > -1 ||
          ((f.CURP ?? "").toLocaleLowerCase() as string).indexOf(
            this.filtro.toLocaleLowerCase().trim(),
          ) > -1 ||
          ((f.Razon ?? "").toLocaleLowerCase() as string).indexOf(
            this.filtro.toLocaleLowerCase().trim(),
          ) > -1,
      );
    this.list = filterdata;
  }
  saveForm(e: { mode: string; value: any; file: File }) {
    if (e.mode == "create") {
      if (e.file) this.guardarConImagen(e.value, e.file);
      else this.guardar(e.value);
    } else if (e.mode == "update") {
      if (e.file) this.actualizarConImagen(e.value, e.file);
      else this.actualizar(e.value);
    }
  }
  guardar(row: any) {
    this.service.add(row).subscribe(
      (next) => {
        this.alerts.correcta("Creado", "Accion realizada correctamente");
        this.formulario.setStanby();
        this.loadRecords();
      },
      (err) => {
        this.alerts.error("error", err.error.Message);
      },
    );
  }
  actualizar(row: any) {
    this.service.update(row).subscribe(
      (next) => {
        this.alerts.correcta("Actualizado", "Accion realizada correctamente");
        this.formulario.setStanby();
        this.loadRecords();
      },
      (err) => {
        this.alerts.error("error", err.error.Message);
      },
    );
  }

  guardarConImagen(row: any, imagen: File) {
    this.service.addWithFile(row, imagen).subscribe(
      (next) => {
        this.alerts.correcta("Creado", "Accion realizada correctamente");
        this.formulario.setStanby();
        this.loadRecords();
      },
      (err) => {
        this.alerts.error("error", err.error.Message);
      },
    );
  }

  actualizarConImagen(row: any, imagen: File) {
    this.service.updateWithFile(row, imagen).subscribe(
      (next) => {
        this.alerts.correcta("Actualizado", "Accion realizada correctamente");
        this.formulario.setStanby();
        this.loadRecords();
      },
      (err) => {
        this.alerts.error("error", err.error.Message);
      },
    );
  }


    openUser() {
      const drawerRef = this.drawer.open({
        component: BlackilistDrawerForm,
        data: { mode: "create", value: {} },
        width: "500px",
        title: "Trabajador en lista negra",
        classes: "bg-blueGray-100",
        actions: [
          {
            label: "Cancel",
            action: () => this.drawer.close(),
            buttonClass: "bg-red-600",
          },
          {
            label: "Guardar",
            action: (component: BlackilistDrawerForm) => component.saveOver(),
          },
        ],
      });

      drawerRef.afterClosed$.subscribe((result: any) => {
        this.saveForm(result.data);
      });
    }

    override openEdit(value: any) {
      const drawerRef = this.drawer.open({
        component: BlackilistDrawerForm,
        data: { mode: "update", value: value },
        width: "500px",
        title: "Trabajador en lista negra",
        classes: "bg-blueGray-100",
        actions: [
          {
            label: "Cancel",
            action: () => this.drawer.close(),
            buttonClass: "bg-red-600",
          },
          {
            label: "Actualizar",
            action: (component: BlackilistDrawerForm) => component.saveOver(),
          },
        ],
      });

      drawerRef.afterClosed$.subscribe((result: any) => {
        this.saveForm(result.data);
      });
    }
    public tableActionsCC = [
      {
        label: "Nuevo",
        icon: "plus",
        className:
          "text-xs font-bold uppercase px-3 py-2 rounded shadow hover:shadow-md bg-blueGray-600 text-white disabled:opacity-50",
        action: () => this.openUser(),
      },
    ];
}
